import React, { FC, ReactElement, useEffect, useState } from 'react';
// import cns from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import {
    getPopupQuizList,
    IQuizItemPopup,
    IStoredQuizActivity,
    QUIZ_STORAGE,
    updateQuizActivityDay
} from '../../../../stores/reducers/quiz';
import { IQuizModalData } from './Quiz';
import QuizModal from './QuizModal';
import { getAllSections } from '../../../../stores/reducers/sections';
import moment from 'moment';
import { storageFactory } from 'src/helpers/storage';
import { getIsLoggedIn } from '../../../../stores/reducers/userData';

const local = storageFactory(() => localStorage);

const QuizPopup: FC = (): ReactElement => {
    const dispatch = useDispatch();
    const isUserAuth = useSelector(getIsLoggedIn);
    const quizList: IQuizItemPopup[] = useSelector(getPopupQuizList);
    const filteredQuizList = quizList.filter((quiz: IQuizItemPopup) => {
        if (quiz.access === 0) {
          if (isUserAuth) {
            return quiz;
          }
          return null;
        }
          return quiz;
    });
    const quizPopupSection: any = useSelector(getAllSections).find((section) => section.id === 19) || [];
    
    const [quizModalData, setQuizModalData] = useState<IQuizModalData>({
        isOpen: false,
        close: () => setQuizModalData({ ...quizModalData, isOpen: false }),
        quiz: null,
    });

    const currentDate = moment(new Date()).format('DD.MM.YYYY');
    const quizPopupBackground = quizPopupSection.params.find((p: {type: string}) => p.type === 'quizPopupBackground' );
    const quizAnswerBackground = quizPopupSection.params.find((p: {type: string}) => p.type === 'quizAnswerBackground' );
    const quizPopupFontColor = quizPopupSection.params.find((p: {type: string}) => p.type === 'quizPopupFontColor' );
    const quizPopupButtonColor = quizPopupSection.params.find((p: {type: string}) => p.type === 'quizPopupButtonColor' );

    const updateQuizModalData = (quiz: IQuizItemPopup) => {
        setQuizModalData({...quizModalData, isOpen: true, quiz});
    };

    useEffect(() => {
        if (!quizPopupSection.visible || !filteredQuizList.length) return;
        
        const storageActiveDates = JSON.parse(local.getItem(QUIZ_STORAGE) || '[]');

        filteredQuizList.forEach((quiz) => {            
            if (!quiz.hasAnswers && quiz.lastActiveDate !== currentDate) {
                const storageItemIndex = storageActiveDates.findIndex((item: IStoredQuizActivity) => item.id === quiz.id);
                setTimeout(() => {
                    updateQuizModalData(quiz);
                    if (storageItemIndex !== -1) {
                        storageActiveDates[storageItemIndex].date = currentDate;
                    } else {
                        storageActiveDates.push({id: quiz.id, date: currentDate});
                    }
                    dispatch(updateQuizActivityDay({id: quiz.id, date: currentDate}));
                    local.setItem(QUIZ_STORAGE, JSON.stringify(storageActiveDates));
                }, quiz.timeout);
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isUserAuth, quizPopupSection.visible]);

    return (
        quizPopupSection.visible === true || quizList.length > 0 ?
            <QuizModal
            isOpen={quizModalData.isOpen}
            close={quizModalData.close}
            quiz={quizModalData.quiz}
            styles={{
                backgroundColor: quizPopupBackground.value,
                activeColor: quizAnswerBackground.value,
                questionColor: quizPopupFontColor.value,
                buttonColor: quizPopupButtonColor.value,
            }}
            />
        :
            <></>
    );
};

export default QuizPopup;
